var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPendingReceive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.909,
    height: 34.111,
    viewBox: "0 0 37.909 34.111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pending_Receive",
    "data-name": "Pending Receive",
    transform: "translate(-976.5 -242.944)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "document-svgrepo-com_1_",
    "data-name": "document-svgrepo-com (1)",
    transform: "translate(975 242.444)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M3,14.444c0-5.866,0-8.8,1.822-10.622S9.578,2,15.444,2h3.111c5.866,0,8.8,0,10.622,1.822S31,8.578,31,14.444v6.222c0,5.866,0,8.8-1.822,10.622s-4.756,1.822-10.622,1.822H15.444c-5.866,0-8.8,0-10.622-1.822S3,26.533,3,20.667Z",
    transform: "translate(0)",
    fill: "none",
    stroke: "#878a99",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M8,10H20.444",
    transform: "translate(2.778 4.444)",
    fill: "none",
    stroke: "#878a99",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M8,14h7.778",
    transform: "translate(2.778 6.667)",
    fill: "none",
    stroke: "#878a99",
    strokeLinecap: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 9,
    height: 20,
    transform: "translate(1001 249)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary",
    d: "M12.416,3V23.493M9,20.078l3.416,3.416,3.416-3.416",
    transform: "matrix(0.891, 0.454, -0.454, 0.891, 999.951, 239.561)",
    fill: "none",
    stroke: "#878a99",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingReceive);
export default __webpack_public_path__ + "static/media/Pending_Receive.5029eaa221ca52cdfa192db2367daf98.svg";
export { ForwardRef as ReactComponent };